import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "user-card" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "initial" }

import {
  IonItem,
  IonThumbnail,
  IonLabel,
  IonSkeletonText,
  IonButton,
} from "@ionic/vue";
import { PropType } from "vue";
import { IUserCard } from ".";

export default /*#__PURE__*/_defineComponent({
  __name: 'UserCard',
  props: {
  user: {
    type: Object as PropType<IUserCard>,
  },
  route: String,
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.user)
      ? (_openBlock(), _createBlock(_unref(IonItem), {
          key: 0,
          "router-link": __props.route
        }, {
          default: _withCtx(() => [
            (__props.user.picture && __props.user.picture !== '')
              ? (_openBlock(), _createBlock(_unref(IonThumbnail), {
                  key: 0,
                  slot: "start"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      alt: "Silhouette of a person's head",
                      src: __props.user.picture
                    }, null, 8, _hoisted_2)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (!__props.user.picture || __props.user.picture === '')
              ? (_openBlock(), _createBlock(_unref(IonThumbnail), {
                  key: 1,
                  slot: "start"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, _toDisplayString(__props.user.name[0]), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_unref(IonLabel), null, {
              default: _withCtx(() => [
                _createElementVNode("h3", null, _toDisplayString(__props.user.name), 1),
                _createElementVNode("p", null, _toDisplayString(__props.user.detail), 1),
                (__props.user.checkin_status === 1)
                  ? (_openBlock(), _createBlock(_unref(IonButton), {
                      key: 0,
                      class: "status_button",
                      size: "small",
                      color: "registered"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Registered")
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (__props.user.checkin_status === 2)
                  ? (_openBlock(), _createBlock(_unref(IonButton), {
                      key: 1,
                      class: "status_button",
                      size: "small",
                      color: "entered"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Entered")
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (__props.user.checkin_status === 3)
                  ? (_openBlock(), _createBlock(_unref(IonButton), {
                      key: 2,
                      class: "status_button",
                      size: "small",
                      color: "checkedout"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Checked out")
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _renderSlot(_ctx.$slots, "default")
          ]),
          _: 3
        }, 8, ["router-link"]))
      : _createCommentVNode("", true),
    (!__props.user)
      ? (_openBlock(), _createBlock(_unref(IonItem), { key: 1 }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonThumbnail), { slot: "start" }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonSkeletonText), { animated: true })
              ]),
              _: 1
            }),
            _createVNode(_unref(IonLabel), null, {
              default: _withCtx(() => [
                _createElementVNode("h3", null, [
                  _createVNode(_unref(IonSkeletonText), {
                    animated: true,
                    style: {"width":"80%"}
                  })
                ]),
                _createElementVNode("p", null, [
                  _createVNode(_unref(IonSkeletonText), {
                    animated: true,
                    style: {"width":"60%"}
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})